module.exports = __webpack_public_path__ + "static/media/dish_unselected.766fb6b2.svg";